import React from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Alert, InternalLink, Text, constants } from "@thecb/components";
import { TEXT_PRIMARY } from "@/constants/colors";

const bannerStyles = `
  min-height: 0;
  margin-bottom: 1.625rem;
  > div > div {
    align-items: center;
  }
  /* An inline svg leaves a baseline gap under the icon, which throws off the centering. */
  svg {
    display: block;
  }
`;

const linkHoverStyles = `
  color: ${constants.colors.LUCKY_POINT};
  text-decoration-thickness: 0.125rem;
`;
const linkActiveStyles = `
  color: ${constants.colors.LUCKY_POINT_DARK};
  text-decoration-thickness: 0.125rem;
`;
const linkStyles = `
  display: inline;
  &:focus:not(:focus-visible) {
    outline: none;
  }
`;

const PaymentsBetaBanner = () => {
  const flags = useFlags();
  const paymentsBetaTabEnabled = flags?.["revm-payments-beta-tab"];

  if (!paymentsBetaTabEnabled) {
    return null;
  }

  return (
    <Alert
      variant="announcement"
      showQuitLink={false}
      padding="0.875rem 1.375rem"
      iconPadding="0"
      innerContentPadding="0 0 0 0.75rem"
      extraStyles={bannerStyles}
      textOverride={
        <Text variant="p" color={TEXT_PRIMARY} dataQa="Payments beta banner">
          A new and improved Payments experience is coming soon. Click{" "}
          <InternalLink
            to="/payments-beta"
            color={TEXT_PRIMARY}
            fontWeight="700"
            dataQa="Payments beta link"
            extraStyles={linkStyles}
            extraHoverStyles={linkHoverStyles}
            extraActiveStyles={linkActiveStyles}
          >
            Payments - Beta
          </InternalLink>{" "}
          to start using it today!
        </Text>
      }
    />
  );
};

export default PaymentsBetaBanner;
